import VueRouter from 'vue-router';
import routes from './routes';

const router = new VueRouter({ routes });

router.beforeEach((to, from, next) => {
  if (!localStorage.getItem('uid') && to.params.id) {
    localStorage.setItem('directSurveyId', to.params.id);
  }
  if (to.name !== 'Login' && !localStorage.getItem('uid')) {
    next({ name: 'Login' });
  } else if (to.name === 'Login' && localStorage.getItem('uid')) {
    if (localStorage.getItem('directSurveyId')) {
      next(`/${localStorage.getItem('directSurveyId')}`);
    } else {
      next('/home');
    }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js